/* eslint-disable max-len */
import AppConfig from 'utils/app-config';

class GoogleService {
  init() {
    return new Promise((resolve) => {
      if (AppConfig.get('googleInitialized')) {
        return resolve();
      }

      const initClientCallback = () => {
        const client = window.google.accounts.oauth2.initTokenClient({
          client_id: AppConfig.get('googleId'),
          scope: 'openid https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email',
          ux_mode: 'popup',
          callback: ({ access_token: accessToken }) => localStorage.setItem('access_token', accessToken),
          error_callback: () => localStorage.setItem('oauth_failed', true),
        });

        window.googleClient = client;

        AppConfig.merge({ googleInitialized: true });

        return resolve();
      };

      (function googleScriptInjection(d, s, id) {
        const fjs = d.getElementsByTagName(s)[0] || d.getElementsByTagName('body')[0];
        if (d.getElementById(id)) { return; }
        const js = d.createElement(s);
        js.id = id;
        js.aync = true;
        js.defer = true;
        js.onload = initClientCallback;
        js.src = 'https://accounts.google.com/gsi/client';
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'google-jssdk'));

      return true;
    });
  }

  login() {
    return new Promise((resolve, reject) => {
      window.googleClient.requestAccessToken();

      let currentRetries = 0;
      const maxRetries = 10;

      const authLoop = setInterval(() => {
        const accessToken = localStorage.getItem('access_token');
        const oauthFailed = localStorage.getItem('oauth_failed');

        const hasAlreadyLoggedIn = accessToken && typeof accessToken === 'string';
        const hasFailedOauth = oauthFailed && typeof oauthFailed === 'string';

        if (hasAlreadyLoggedIn) {
          clearInterval(authLoop);
          localStorage.removeItem('access_token');

          resolve(accessToken);
        }

        if (hasFailedOauth) {
          clearInterval(authLoop);
          localStorage.removeItem('oauth_failed');

          const errorCodeForIntegrationFailure = 500;
          // eslint-disable-next-line
          reject({ code: errorCodeForIntegrationFailure });
        }

        if (currentRetries === maxRetries) {
          clearInterval(authLoop);

          const errorCodeForLoginExpiration = 408;
          // eslint-disable-next-line
          reject({ code: errorCodeForLoginExpiration });
        }

        currentRetries += 1;
      }, 1500);
    });
  }
}

export default new GoogleService();
